import { TELEMETRY_DEFAULT_SORT } from "~/constants/telemetry";

export default () => ({
  telemetryEntries: null,
  loading: false,
  page: 0,
  sortBy: TELEMETRY_DEFAULT_SORT.sortBy,
  orderBy: TELEMETRY_DEFAULT_SORT.orderBy,
  search: "",
});
